import { render, staticRenderFns } from "./error.vue?vue&type=template&id=6f98e63d"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f98e63d')) {
      api.createRecord('6f98e63d', component.options)
    } else {
      api.reload('6f98e63d', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=6f98e63d", function () {
      api.rerender('6f98e63d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/error.vue"
export default component.exports